/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpackpending2Inputs */

const en_creditpackpending2 = /** @type {(inputs: Creditpackpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment is still being confirmed. The credits will arrive shortly.`)
};

const de_creditpackpending2 = /** @type {(inputs: Creditpackpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Zahlung wird noch bestätigt. Die Credits kommen in Kürze.`)
};

/**
* | output |
* | --- |
* | "Your payment is still being confirmed. The credits will arrive shortly." |
*
* @param {Creditpackpending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditpackpending2 = /** @type {((inputs?: Creditpackpending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpackpending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditpackpending2(inputs)
	return de_creditpackpending2(inputs)
});
export { creditpackpending2 as "creditPackPending" }